import { Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { AnyAction } from 'redux';
import { ThunkAction } from '@reduxjs/toolkit';
import { assetTypeConfigs } from './asset-type';
import { FilterScope, getScope } from './translations';
import { authorityConfigs } from './authority';
import { sourceConfigs } from './source';
import { versionConfigs } from './version';
import { visibilityConfigs } from './visibility';
import { I18n } from 'common/i18n';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { FilterType, SelectOption } from './types';

interface BaseConfig {
  filterName: Filters;
  label: string;
}

export interface CheckboxConfig extends BaseConfig {
  dispatchAction: () => AppThunk;
  filterType: FilterType.Checkbox;
}

export interface SelectDropdownConfig extends BaseConfig {
  getOptions: (list?: any) => SelectOption[];
  dispatchAction: (value: string | null) => AppThunk;
  filterType: FilterType.SelectDropdown;
}

type FilterEntry = CheckboxConfig | SelectDropdownConfig;

type AppThunk = ThunkAction<any, any, unknown, AnyAction>;

export const FilterLookup: Partial<Record<Filters, FilterEntry>> = {
  onlyRecentlyViewed: {
    filterName: Filters.OnlyRecentlyViewed,
    label: I18n.t('label', { scope: getScope(FilterScope.RecentlyViewed) }),
    dispatchAction: filters.toggleRecentlyViewed,
    filterType: FilterType.Checkbox,
  },
  enrolledInArchival: {
    filterName: Filters.EnrolledInArchival,
    label: I18n.t('label', { scope: getScope(FilterScope.EnrolledInArchival) }),
    dispatchAction: filters.toggleEnrolledInArchival,
    filterType: FilterType.Checkbox,
  },
  approvalStatus: {
    filterName: Filters.ApprovalStatus,
    label: I18n.t('awaiting_approval', { scope: 'shared.asset_browser.filters' }),
    dispatchAction: filters.toggleAwaitingApproval,
    filterType: FilterType.Checkbox,
  },
  showInternalTargetAudience: {
    filterName: Filters.ShowInternalTargetAudience,
    label: I18n.t('internal', { scope: getScope(FilterScope.ApprovalTypes) }),
    dispatchAction: filters.toggleInternalTargetAudience,
    filterType: FilterType.Checkbox,
  },
  showPublicTargetAudience: {
    filterName: Filters.ShowPublicTargetAudience,
    label: I18n.t('public', { scope: getScope(FilterScope.ApprovalTypes) }),
    dispatchAction: filters.togglePublicTargetAudience,
    filterType: FilterType.Checkbox,
  },
  authority: authorityConfigs,
  assetTypes: assetTypeConfigs,
  source: sourceConfigs,
  version: versionConfigs,
  visibility: visibilityConfigs,
};
